var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verification-form__wrap" }, [
    _c(
      "form",
      {
        staticClass: "verification-form",
        attrs: { novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          }
        }
      },
      [
        _vm.isPending
          ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "text_large verification-form__title" }, [
          _vm._v(_vm._s(_vm.i18n.kyc_account_verification()))
        ]),
        _vm._v(" "),
        _c(
          "md-steppers",
          {
            attrs: { "md-linear": "", "md-active-step": _vm.activeStep },
            on: {
              "update:mdActiveStep": function($event) {
                _vm.activeStep = $event
              },
              "update:md-active-step": function($event) {
                _vm.activeStep = $event
              }
            }
          },
          _vm._l(_vm.steps, function(step, i) {
            return _c(
              "md-step",
              {
                key: i,
                attrs: {
                  id: step.name,
                  "md-label": step.label,
                  "md-done": step.done
                },
                on: {
                  "update:mdDone": function($event) {
                    return _vm.$set(step, "done", $event)
                  },
                  "update:md-done": function($event) {
                    return _vm.$set(step, "done", $event)
                  }
                }
              },
              [
                _c(step.component, {
                  tag: "component",
                  attrs: {
                    schema: step.schema,
                    activeStep: _vm.activeStep,
                    finalStep: _vm.finalStep,
                    kyc: _vm.kyc
                  },
                  on: {
                    "kyc-update": function($event) {
                      return _vm.handleKycUpdate($event, { step: step, i: i })
                    },
                    "kyc-edit-end": _vm.handleKycEditEnd
                  }
                })
              ],
              1
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d5bb642", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d5bb642","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/verification/make/Verification.Individual.vue
// module id = VxPq
// module chunks = 1